import request from '@/utils/request'

// 登录方法
export function login(data) {
  return request({
    url: '/api/pc/login2',
    method: 'post',
    data: data,
    isToken:false
  })
}
// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 登录方法2
export function login2(data) {
  return request({
    url: '/login2',
    method: 'post',
    data: data,
    isToken:true
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/api/client/loginOut',
    method: 'post'
  })
}
// 商户接口
export function getAllMerchant() {
  return request({
    url: '/api/pc/merchant/getAllMerchant',
    method: 'post',
    isToken:false
  })
}
// 验证码
export function sendRegisterCode(query) {
  return request({
    url: '/api/pc/sendRegisterCode',
    method: 'get',
    params: query,
    isToken:false
  })
}
// 获取验证码
export function getCodeImg() {
  return request({
    url: '/pc/captcha/captchaImage',
    method: 'get',
    isToken:false
  })
}
// 忘记密码获取验证码
export function sendYzmCode(data) {
  return request({
    url: '/api/pc/customer/sendForgetPwdCode',
    method: 'get',
    params: data
  })
}
// 忘记密码确定
export function forgetpassword(data) {
  return request({
    url: '/api/pc/customer/updatePwdByCode',
    method: 'get',
    params: data
  })
}
export function chooseCusetomerLogin(data) {
  return request({
    url: '/api/pc/chooseCusetomerLogin',
    method: 'post',
    data: data
  })
}

//注册
export function registerVerify(data) {
  return request({
    url: '/api/pc/customerRegister',
    method: 'post',
    data: data
  })
}


//注册
export function customerRegister(data) {
  return request({
    url: '/customerRegister',
    method: 'post',
    data: data
  })
}
//登录方法
export function loginConfig(data) {
  return request({
    url: '/api/merchant/loginConfig/selectByMerchantId',
    method: 'get',
    params: data
  })
}
//获取验证码
export function sendCode(data) {
  return request({
    url: '/api/client/sendCode',
    method: 'get',
    params: data
  })
}
//验证码登录
export function loginSms(data) {
  return request({
    url: '/api/client/loginSms',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js